import { useState, useEffect } from "react";
import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "./loyaltyFetch";

/**
 * GET /admin/customer-entitlements/ui-catalog — libellés statuts coupon client.
 */
export function useCustomerEntitlementsCatalog(brandName) {
    const [catalog, setCatalog] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!brandName) {
            setCatalog(null);
            return;
        }
        let cancelled = false;
        setLoading(true);
        loyaltyFetch(`${LOYALTY_API_BASE}/admin/customer-entitlements/ui-catalog`, {
            headers: { "X-Brand": brandName },
        })
            .then(async (res) => {
                const data = res.ok ? await res.json().catch(() => null) : null;
                if (!cancelled) setCatalog(data);
            })
            .catch(() => { if (!cancelled) setCatalog(null); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [brandName]);

    const statusLabels = catalog?.coupon_status_labels
        || catalog?.status_labels
        || catalog?.statuses
        || null;

    return { catalog, statusLabels, loading };
}
